// Render call-detail dropdown menus above the MUI modal-layer drawer
// (z-index 1300) that hosts the call detail in workspace panels.
export const MENU_Z_INDEX_ABOVE_DRAWER = 1301;
